// helvar actions
import {daliHelvarConstants} from "../constants/dali-helvar.constants";
import {daliHelvarService} from "../services/dali-helvar.service";
import {modalActions} from "./modal.actions";

// region area
const getHelvarArea = (networkDeviceId) => {
    return dispatch  => {
        daliHelvarService.getArea(networkDeviceId)
            .then(
                (areaModel) => {
                    dispatch({type: daliHelvarConstants.HELVAR_AREA_LIST_SUCCESS, areaModel})
                },
                (error) => {
                    dispatch({type: daliHelvarConstants.HELVAR_AREA_LIST_FAILURE, error})
                }
            )
    }
};

const getHelvarAreaById = (areaId) => {
    return dispatch => {
        daliHelvarService.getAreaById(areaId)
            .then(
                (areaSingleModel) => {
                    dispatch({type: daliHelvarConstants.HELVAR_AREA_ITEM_SUCCESS, areaSingleModel})
                },
                (error) => {
                    dispatch({type: daliHelvarConstants.HELVAR_AREA_ITEM_FAILURE, error})
                }
            )
    }
};

const createHelvarArea = (areaModel) => {
    return dispatch => {
        daliHelvarService.createArea(areaModel)
            .then(
                (res) => {
                    dispatch(getHelvarArea(res.networkDeviceId));
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    console.log("errorValidation: " + error)
                }
            )
    }
};

const editHelvarArea = (areaModel) => {
    return dispatch => {
        daliHelvarService.editArea(areaModel)
            .then(
                (res) => {
                    dispatch(getHelvarArea(res.networkDeviceId));
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    console.log("errorValidation: " + error)
                }
            )
    }
};

const deleteHelvarArea = (areaId, deviceId) => {
    return dispatch => {
        daliHelvarService.deleteArea(areaId)
            .then(
                (res) => {
                    dispatch(getHelvarArea(deviceId));
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    console.log(error)
                }
            )
    }
};

// region group
const getHelvarGroups = (networkDeviceId) => {
    return dispatch => {
        daliHelvarService.getGroups(networkDeviceId)
            .then(
                (groupsModel) => {
                    dispatch({type: daliHelvarConstants.HELVAR_GROUP_LIST_SUCCESS, groupsModel})
                },
                (error) => {
                    dispatch({type: daliHelvarConstants.HELVAR_GROUP_LIST_FAILURE, error})
                }
            )
    }
};

const createHelvarGroup = (groupModel) => {
    return dispatch => {
        daliHelvarService.createGroup(groupModel)
            .then(
                (res) => {
                    dispatch(getHelvarGroups(res.networkDeviceId));
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    console.log(error)
                }
            )
    }
};

const editHelvarGroup = (groupModel) => {
    return dispatch => {
        daliHelvarService.editGroup(groupModel)
            .then(
                (res) => {
                    dispatch(getHelvarGroups(res.networkDeviceId));
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    console.log(error)
                }
            )
    }
};

const deleteHelvarGroup = (groupId, networkDeviceId) => {
    return dispatch => {
        daliHelvarService.deleteGroup(groupId)
            .then(
                () => {
                    dispatch(getHelvarGroups(networkDeviceId));
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    console.log(error)
                }
            )
    }
};

const getHelvarGroupById = (groupId) => {
    return dispatch => {
        daliHelvarService.getGroupById(groupId)
            .then(
                (groupItem) => {
                    dispatch({type: daliHelvarConstants.HELVAR_GROUP_ITEM_SUCCESS, groupItem})
                },
                (error) => {
                    dispatch({type: daliHelvarConstants.HELVAR_GROUP_ITEM_FAILURE, error})
                }
            )
    }
};

// region scenes
const getHelvarScenes = (groupId) => {
    return dispatch => {
        daliHelvarService.getScenes(groupId)
            .then(
                (scenesModel) => {
                    dispatch({type: daliHelvarConstants.HELVAR_SCENE_LIST_SUCCESS, scenesModel})
                },
                (error) => {
                    dispatch({type: daliHelvarConstants.HELVAR_SCENE_LIST_FAILURE}, error)
                }
            )
    }
};

const createHelvarScene = (sceneModel) => {
    return dispatch => {
        daliHelvarService.createScene(sceneModel)
            .then(
                (sceneModel) => {
                    dispatch(getHelvarScenes(sceneModel.daliHelvarGroupId));
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    dispatch({type: daliHelvarConstants.HELVAR_VALIDATION_FORM, error})
                }
        );
    }
};

const editHelvarScene = (sceneModel) => {
    return dispatch => {
        daliHelvarService.editScene(sceneModel)
            .then(
                (sceneModel) => {
                    dispatch(getHelvarScenes(sceneModel.daliHelvarGroupId));
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    dispatch({type: daliHelvarConstants.HELVAR_VALIDATION_FORM, error})
                }
            );
    }
};

const deleteHelvarScene = (sceneId, groupId) => {
    return dispatch => {
        daliHelvarService.deleteScene(sceneId)
            .then(
                () => {
                    dispatch(getHelvarScenes(groupId));
                    dispatch(modalActions.hideModal())
                },
                (error) => {
                    dispatch({type: daliHelvarConstants.HELVAR_SCENE_LIST_FAILURE, error})
                }
            )
    }
};

const clearHelvarStore = () => {
    return dispatch => {
        dispatch({type: daliHelvarConstants.HELVAR_CLEAR})
    }
};

export const daliHelvarActions = {
    // helvar area
    getHelvarArea,
    getHelvarAreaById,
    createHelvarArea,
    editHelvarArea,
    deleteHelvarArea,
    // helvar group
    getHelvarGroups,
    createHelvarGroup,
    editHelvarGroup,
    deleteHelvarGroup,
    getHelvarGroupById,
    // helvar scenes
    getHelvarScenes,
    createHelvarScene,
    editHelvarScene,
    deleteHelvarScene,
    // other
    clearHelvarStore
};
